import React, { forwardRef } from 'react';
import { SvgIconProps, useTheme } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

interface DSHelpOutlineProps extends SvgIconProps {
  component?: React.ElementType;
}

const DSHelpOutline = forwardRef<SVGSVGElement, DSHelpOutlineProps>(
  (props, ref) => {
    const { spacing } = useTheme();

    return (
      <HelpOutline
        ref={ref}
        {...props}
        sx={{ height: spacing(2), width: spacing(2), ...props.sx }}
      />
    );
  },
);

export default DSHelpOutline;
